import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  providers: [provideTranslocoScope('customers')],
  selector: 'cus-customers',
  imports: [TranslocoPipe, ],
  templateUrl: './customers.html',
  styleUrl: './customers.css',
})
export class Customers {

}
